import { motion } from "framer-motion";

const RINGS = [
    { inset: "0%", dashed: false },
    { inset: "12%", dashed: true },
    { inset: "26%", dashed: false },
    { inset: "40%", dashed: true },
];

export default function OrbitalInstrument() {
    return (
        <div
            data-testid="hero-orbital-instrument"
            className="relative mx-auto aspect-square w-full max-w-[300px] sm:max-w-[440px] lg:max-w-[520px]"
        >
            {RINGS.map((r, i) => (
                <motion.div
                    key={i}
                    initial={{ opacity: 0, scale: 0.7 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.4 + i * 0.15, duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
                    className={`absolute rounded-full border ${
                        r.dashed ? "border-dashed border-white/15" : "border-white/10"
                    }`}
                    style={{ inset: r.inset }}
                />
            ))}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 1 }}
                className="absolute left-1/2 top-1/2 h-[18%] w-[18%] -translate-x-1/2 -translate-y-1/2 rounded-full"
                style={{
                    background:
                        "radial-gradient(circle at 38% 34%, #EBD3A4 0%, #D9B36C 34%, #7A5A25 78%, rgba(122,90,37,0) 100%)",
                    boxShadow:
                        "0 0 60px rgba(217,179,108,0.45), 0 0 140px rgba(143,199,255,0.18)",
                }}
            />
            <div className="absolute inset-0 animate-spin-slow">
                <span className="absolute left-1/2 top-0 h-2 w-2 -translate-x-1/2 rounded-full bg-celestial-blue shadow-[0_0_16px_rgba(143,199,255,0.9)]" />
            </div>
            <div className="absolute inset-[12%] animate-spin-slower">
                <span className="absolute left-1/2 top-0 h-1.5 w-1.5 -translate-x-1/2 rounded-full bg-celestial-gold shadow-[0_0_14px_rgba(217,179,108,0.9)]" />
            </div>
            <div className="absolute inset-[26%] animate-spin-slow" style={{ animationDuration: "44s" }}>
                <span className="absolute right-0 top-1/2 h-1.5 w-1.5 translate-y-1/2 rounded-full bg-white/80 shadow-[0_0_12px_rgba(255,255,255,0.8)]" />
            </div>
        </div>
    );
}
